const setLoggedStatus = ({ commit }, payload) =>
  commit('SETLOGGEDSTATUS', payload)

export default {
  setLoggedStatus
}
